/*
* create by nguyendx 2017/10/25
*/
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialogModule, GrowlModule, TooltipModule } from 'primeng/primeng';
import { HelperModule } from '../../../../common/helper/helper.module';
import { UploadEvsService } from '../../../../common/services/UploadEvs.service';
import { StoreListComponent } from './store_list.component';
import { StoreAddComponent } from './store_add.component';
import { StoreEditComponent } from './store_edit.component';
import { SelectModule } from 'ng-select';
import { CardModule } from '../../../../layout/card';
import { PaginationModule } from '../../../../layout/pagination';
import { ToastrModule } from 'ngx-toastr';
import { AgmCoreModule } from '@agm/core';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { ModalModule } from 'ngx-bootstrap/modal';
/*
 * create by tuanba 2022/03/14
 */
import { StoreSaleComponent } from './store-sale/store-sale.component';
import { StoreSaleAddComponent } from './store-sale/store-sale_add.component';
import { StoreSaleEditComponent } from './store-sale/store-sale_edit.component';
import { EvsProductsModule } from '../product/product.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ConfirmDialogModule,
    GrowlModule,
    TooltipModule,
    BrowserModule,
    HelperModule,
    SelectModule,
    CardModule,
    PaginationModule,
    ToastrModule.forRoot(),
    ModalModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyC0fgs5qkpOIDJRXBNG8mNApwwFk30qhMs'
    }),
    BsDatepickerModule.forRoot(), EvsProductsModule, TranslateModule
  ],
  // tslint:disable-next-line:max-line-length
  declarations: [StoreListComponent, StoreAddComponent, StoreEditComponent, StoreSaleComponent, StoreSaleAddComponent, StoreSaleEditComponent],
  exports: [StoreListComponent, StoreAddComponent, StoreEditComponent],

  providers: [UploadEvsService]
})

export class StoreModule {
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/store_manager/store.module.ts